function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.356,101.661l3.813-3.813a.566.566,0,0,0,0-.8l-.886-.886a.566.566,0,0,0-.8,0L5.671,99.976,1.858,96.163a.566.566,0,0,0-.8,0l-.886.886a.566.566,0,0,0,0,.8l3.813,3.813L.173,105.474a.566.566,0,0,0,0,.8l.886.886a.566.566,0,0,0,.8,0l3.813-3.813,3.813,3.813a.566.566,0,0,0,.8,0l.886-.886a.566.566,0,0,0,0-.8Z",
  transform: "translate(-0.007 -95.998)",
  fill: "#222"
});

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.327,
    height: 11.328,
    viewBox: "0 0 11.327 11.328"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Close.ee74353a.svg";
export { SvgClose as ReactComponent };